// --- Vendors ---
import Isotope from 'isotope-layout';
import Masonry from 'masonry-layout';
import jQueryBridget from 'jquery-bridget';
import GLightbox from 'glightbox';

// --- Components ---
const home = {
    readyFn: function () {
        jQueryBridget('masonry', Masonry, $);
        jQueryBridget('isotope', Isotope, $);

        console.log("Home");

        const lightbox = GLightbox({
            loop: true,
        });

        // Initialisation de l'Isotope
        var $gridActivite = $('.grid-image').isotope({
            itemSelector: '.grid-item',
        });

        // Gestion du filtre sur les tags
        $(".tag-list .tag").on("click", function () {
            var $this = $(this); // Référence à l'élément cliqué

            // Vérifie si l'élément cliqué est le bouton "Tous"
            if ($this.hasClass("all")) {
                $(".tag-list .tag").removeClass("actif");
                $gridActivite.isotope({
                    filter: '' // Réinitialisation du filtre pour afficher tous les éléments
                });
                $(this).addClass("actif");
            } else {
                // Gère l'ajout et la suppression de la classe "actif" pour le tag cliqué
                $(".tag.all").removeClass("actif");
                $this.toggleClass("actif");

                // Récupère les valeurs des filtres actifs
                var filterValue = $(".tag-list .tag.actif").map(function () {
                    return $(this).attr("data-filter");
                }).get().join('');

                // Si aucun filtre n'est actif, rétablit l'état actif sur le tag "Tous"
                if (!filterValue) {
                    $(".tag.all").addClass("actif");
                }

                // Applique le filtre Isotope
                $gridActivite.isotope({
                    filter: filterValue
                });

                // Debug pour voir les filtres appliqués
                console.log("filterValues : " + filterValue);
            }
        });


        $("#filtre-activite").on("change", function () {
            var filterValue = $(this).val();
            $gridActivite.isotope({
                filter: filterValue
            });
        });


        const videos = document.querySelectorAll('video.js-lazy-video');

        const loadVideo = (video) => {
            if (video.dataset.loaded) return;

            const src = video.dataset.src;
            if (!src) return;

            const source = document.createElement('source');
            source.src = src;
            source.type = 'video/mp4';
            video.appendChild(source);

            video.load();
            video.dataset.loaded = "1";
        };

        // Lazy load quand visible
        const io = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadVideo(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: '200px' });

        videos.forEach(video => {
            io.observe(video);

            const wrapper = video.closest('.grid-wrapper');

            if (wrapper) {
                wrapper.addEventListener('mouseenter', () => {
                    loadVideo(video);
                    video.play().catch(() => { });
                });

                wrapper.addEventListener('mouseleave', () => {
                    video.pause();
                    video.currentTime = 0; // optionnel : reset au début
                });
            }
        });

        $(".creation").on("mouseenter mouseleave", function () {
            $(".single-enchantement." + this.id).toggleClass("actif");
        });

        $(".creation").on("click", function (e) {
            e.stopPropagation();
            $(".single-enchantement").removeClass("actif");
            $(".single-enchantement." + this.id).addClass("actif");
        });

        $(document).on("click", function () {
            $(".single-enchantement").removeClass("actif");
        });

    }
}
export { home };